import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "percent" }
const _hoisted_2 = { class: "number text-md font-bold text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock("svg", null, [
      _createVNode("circle", {
        class: "baseline",
        cx: "50%",
        cy: "50%",
        r: _ctx.RADIUS_OF_THE_OFFSET
      }, null, 8, ["r"]),
      _createVNode("circle", {
        class: "offset",
        style: {
          strokeDasharray: `${_ctx.circumference} ${_ctx.circumference}`,
          strokeDashoffset: `${_ctx.circumference -
            (_ctx.progress / 100) * _ctx.circumference}`,
        },
        cx: "50%",
        cy: "50%",
        r: _ctx.RADIUS_OF_THE_OFFSET
      }, null, 12, ["r"])
    ])),
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", null, _toDisplayString(_ctx.display), 1)
    ])
  ]))
}